import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const VitalsAPI = {
	vitalsGenerateToken: (datasetId: any) => {
		return axios
			.post(`${apiUrl}/generatevitalstoken/datasets/${datasetId}`)
			.then((response) => response.data);
	},
	vitalsGetPayload: (testResultId: number) => {
		return axios
			.get(`${apiUrl}/vitals/getpayload/${testResultId}`)
			.then((response) => response.data);
	},
	vitalsGetTokenRequest: (userId: number) => {
		return axios
			.get(`${apiUrl}/getvitalstoken/${userId}`)
			.then((response) => response.data);
	},
	upsertVitalsTest: (request: UpsertVitalsTestResultRequest) => {
		return axios
			.post(
				`${clientApiUrl}/clients/${request.clientId}/vitals-results`,
				request
			)
			.then((response) => response.data as VitalsTestResultDTO);
	},
	getVitalsTestResult: (request: GetClientSiteVitalsTestResultRequest) => {
		return axios
			.get(
				`${clientApiUrl}/clients/${request.clientId}/vitals-results/${request.vitalsTestResultId}`
			)
			.then((response) => response.data as VitalsTestResultDTO);
	},
	getVitalsLanguageInfo: (request: GetClientSiteVitalsTestLanguageRequest) => {
		return axios
			.get(
				`${clientApiUrl}/clients/${request.clientId}/vitals-language/${request.vitalsTestResultId}`
			)
			.then((response) => response.data as VitalsLanguageDTO);
	},
	getCompletedTasks: (request: VitalsGetCompletedTasksRequest) => {
		return axios
			.get(
				`${clientApiUrl}/vitals/datasets/${request.datasetId}/get-completed-tasks/${request.vitalsTestResultId}`
			)
			.then((response) => response.data as VitalsCompletedTasksDTO[]);
	},
	scoreVitalsTest: (request: VitalsScoreAssessmentRequest) => {
		return axios
			.post(`${clientApiUrl}/vitals/datasets/${request.datasetId}/scorevitals/${request.vitalsTestResultId}`)
			.then((response) => response.data);
	},
};

export default VitalsAPI;
